export default {
  meta: {
    title: '详细地址',
  }
};
